import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addDeclineReason,
  AllDeclineReasons,
  DeleteDeclineReason,
  EditDeclineReason,
} from "../adminApi";
import { addDeclineReasonDto } from "../models";

export const EditDeclineReasonThunk = createAsyncThunk(
  "applicants/EditDeclineReason",
  async (payload: addDeclineReasonDto) => {
    let response: any;
    await EditDeclineReason(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const addDeclineReasonThunk = createAsyncThunk(
  "applicants/addDeclineReason",
  async (payload: addDeclineReasonDto) => {
    let response: any;
    await addDeclineReason(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const DeleteDeclineReasonThunk = createAsyncThunk(
  "DeleteDeclineReason",
  async (declineReasonId: number) => {
    let response: any;
    await DeleteDeclineReason(declineReasonId)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const AllDeclineReasonsThunk = createAsyncThunk(
  "AllDeclineReasons",
  async () => {
    let response: any;
    await AllDeclineReasons()
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);